import { withInstall as o } from "../../utils/with-install.js";
import r from "./overlay.vue.js";
/* empty css             */
const p = o(r);
export {
  p as ApOverlay
};
